import DesignActionButton from './DesignActionButton';

export default function PerformanceJobButtonsPanel() {
  return (
    <div
      style={{
        padding: 0
      }}
    >
      <div
        style={{
          flexDirection: 'row',
          justifyContent: 'center',
          paddingLeft: 0
        }}
      >
        <DesignActionButton
          onClick={(design) => design.startSunAnimation()}
        >
        Sun Animation
        </DesignActionButton>
        <DesignActionButton
          onClick={(design) => design.runIrradiance()}
        >
        Irradiance
        </DesignActionButton>
        <DesignActionButton
          onClick={(design) => design.runPerformanceSimulation()}
        >
        Performance
        </DesignActionButton>
      </div>
    </div>
  );
}

